/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { BroadcastAlertTargetDto } from './broadcast-alert-target-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { BroadcastAlertTranslationDto } from './broadcast-alert-translation-dto';

/**
 * 
 * @export
 * @interface BroadcastAlertDto
 */
export interface BroadcastAlertDto {
    /**
     * Stable slug identifying this announcement, e.g. `datev-export-launch`. Becomes the alert `dedupeKey` (`broadcast:<key>`), which makes a re-send idempotent: a shop that was EVER sent this key is skipped — including one whose merchant has already dismissed it. Re-use the same key to reach shops installed since the first send; use a NEW key for a genuinely new announcement.
     * @type {string}
     * @memberof BroadcastAlertDto
     */
    'broadcastKey': string;
    /**
     * Alert severity. Announcements should be `info`; `error`/`warning` colour the panel as a fault and should be reserved for incidents.
     * @type {string}
     * @memberof BroadcastAlertDto
     */
    'type'?: BroadcastAlertDtoTypeEnum;
    /**
     * Copy for every supported shop locale — exactly one entry per locale, no duplicates, none missing.
     * @type {Array<BroadcastAlertTranslationDto>}
     * @memberof BroadcastAlertDto
     */
    'translations': Array<BroadcastAlertTranslationDto>;
    /**
     * Optional CTA target, identical for all locales. An app-relative path (`/app/exports`), an App Bridge deep link (`shopify://admin/...`), or an absolute `https://` URL. `modal:` action URLs are rejected — those address in-app modals that only the keyed alerts know about.
     * @type {string}
     * @memberof BroadcastAlertDto
     */
    'actionUrl'?: string;
    /**
     * Whether merchants can dismiss the alert. Defaults to true — a non-dismissible announcement sits in the panel until an operator resolves it in the database.
     * @type {boolean}
     * @memberof BroadcastAlertDto
     */
    'isDismissible'?: boolean;
    /**
     * Audience filter. Omit to reach every live shop.
     * @type {BroadcastAlertTargetDto}
     * @memberof BroadcastAlertDto
     */
    'target'?: BroadcastAlertTargetDto;
    /**
     * Resolve the audience and return the per-locale counts and a rendered sample WITHOUT writing any alert or audit row. Defaults to false.
     * @type {boolean}
     * @memberof BroadcastAlertDto
     */
    'dryRun'?: boolean;
    /**
     * Free-text justification stored verbatim in OperatorAuditLog.reason.
     * @type {string}
     * @memberof BroadcastAlertDto
     */
    'reason': string;
}

/**
    * @export
    * @enum {string}
    */
export enum BroadcastAlertDtoTypeEnum {
    Error = 'error',
    Warning = 'warning',
    Info = 'info',
    Success = 'success'
}


